























































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import OperatorModel from '@/_models/OperatorModel'
import SearchUnit from '@/components/modals/SearchUnit.vue'
import NotFound from '@/components/common/NotFound.vue'
import * as DownloadCsv from 'vue-json-csv'
import _ from 'lodash'

@Component({
  components: { SearchUnit, DownloadCsv, NotFound },
  computed: {
    ...mapGetters('operators', {
      canEdit: 'canEdit'
    }),
    ...mapGetters('operators', {
      canDelete: 'canDelete'
    })
  }
})
export default class OperatorList extends Vue {
  // Props
  @Prop()
  private unitId!: any

  // data
  private isPaginated: boolean = true
  private isPaginationSimple: boolean = false
  private paginationPosition: string = 'bottom'
  private defaultSortDirection: string = 'asc'
  private sortIcon: string = 'arrow-up'
  private sortIconSize: string = 'is-small'
  private currentPage: number = 1
  private perPage: number = 10
  private numofPage: number = 1
  private selected: any = {}
  private isFormModalActive: boolean = false
  private isSearchUnitActive: boolean = false
  private searchQuery: string = ''
  private isNew: boolean = false
  private canEdit!: boolean
  private canDelete!: boolean
  private selectedFilter: string = 'operator_name'
  private filedNameLUT: any = {
    _id: 'UUID',
    operator_name: 'label.operator_name',
    unit_name: 'label.unit_name',
    access_right: 'label.access_right'
  }

  private accessRightOptions: any = [
    {
      code: 1,
      label: 'option.access_right.owner'
    },
    {
      code: 2,
      label: 'option.access_right.manager'
    },
    {
      code: 3,
      label: 'option.access_right.observer'
    }
  ]

  // Export csv setting
  private csvFields: any = ['_id', 'operator_name', 'unit_name', 'access_right']

  // computed
  get operators(): OperatorModel[] {
    const operators = this.$store.state.operators.all.items
    this.numofPage = Math.ceil(operators.length / this.perPage)

    if (operators.length && this.hasUnitId) {
      return operators.filter((item: any): boolean => {
        return item.unit_id === this.unitId
      })
    }

    return operators
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.operators.loading
  }

  get selectedUnit(): object {
    return {
      _id: this.selected.unit_id,
      name: this.selected.unit_name
    }
  }

  get hasUnitId(): boolean {
    return !_.isNil(this.unitId)
  }

  get filteredData(): OperatorModel[] {
    const targetField: string = this.selectedFilter
    if (!this.operators) {
      return []
    }

    return this.operators.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  // Handle methods
  private handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.isNew = false
  }

  private selectedUnitDone(data): void {
    this.selected.unit_id = data._id
    this.selected.unit_name = data.name
    this.isSearchUnitActive = false
  }

  private handleOpenModalAdd(data): void {
    this.isFormModalActive = true
    this.selected = new OperatorModel()
    if (this.hasUnitId) {
      this.selected.unit_id = this.unitId
    }

    this.isNew = true
  }

  private async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return false
      }
      if (this.isNew) {
        // add item
        this.$store.dispatch('operators/addOne', this.selected).then(resp => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store
          .dispatch('operators/updateOne', this.selected)
          .then(resp => {
            this.isFormModalActive = false
            this.$buefy.toast.open(this.$t('messages.update_success') as string)
          })
      }
    })
  }

  private handleConfirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      }
    })
  }

  // Method
  private accessRightText(code: number): string | null {
    if (!code) {
      return null
    }

    for (const item of this.accessRightOptions) {
      if (item.code === code) {
        return this.$t(item.label) as string
      }
    }

    return null
  }

  private convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  private processDelete(data): void {
    this.selected = data
    this.$store.dispatch('operators/deleteOne', this.selected).then(() => {
      this.selected = {}
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  // After page created
  private created() {
    this.$store.dispatch('operators/getAll')
  }
}
